export default __webpack_public_path__ + "static/datelabel-dropdown-dont-1-dark-c46ed01b6b89f4088ced027d4539223d2ea8fd89e6351f58e5750246dc830a05.png";